import React, { useContext } from 'react';
import CompanySectionLayout from '../../../../component/B2B/CompanySectionLayout';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/**
 * Company panel → Cessation: the app's two quit programmes.
 *
 *   Overview    how many people are trying to stop something, and how it goes
 *   Last Puff   quitting cigarettes and vaping
 *   Last Drink  quitting alcohol
 *
 * THERE IS NO EMPLOYEES TAB, AND THAT IS THE POINT. Every other section in this
 * panel ends with a per-person list. This one does not, because being enrolled
 * here is itself a disclosure: a list of who is in Last Drink is a list of who
 * has a drinking problem, which is special-category health data and exactly the
 * kind of thing that gets people passed over for promotion. Every figure in
 * this section is a population figure, and small populations are withheld
 * entirely rather than rounded.
 *
 * What the section is for instead: whether the benefit is reaching anybody,
 * whether people stay with it, and when support would land best. All of that
 * is answerable without naming a single person.
 */
const CompanyCessationLayout = ({ children }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const population = isB2BFansMode ? 'members' : 'employees';
  const base = `/${slug}/cessation`;

  const pages = [
    {
      label: 'Overview',
      path: base,
      description: 'Both programmes side by side, and how many people are on both'
    },
    {
      label: 'Last Puff',
      path: `${base}/last-puff`,
      description: 'Quitting cigarettes and vaping — runs, cravings and what people avoided'
    },
    {
      label: 'Last Drink',
      path: `${base}/last-drink`,
      description: 'Quitting alcohol — runs, cravings and what people avoided'
    }
  ];

  return (
    <CompanySectionLayout
      title="Quit Programmes"
      subtitle={`How many of your ${population} are using Last Puff and Last Drink, and how those attempts are going. Aggregate only — nobody is named anywhere in this section, and groups too small to anonymise are not reported at all.`}
      pages={pages}
    >
      {children}
    </CompanySectionLayout>
  );
};

export default CompanyCessationLayout;
